export const imageCtaStyles = {
    imageCta:
        "relative bg-[#181a20] rounded-b-[60px]  min-h-[40rem]",
    imageCtaBackground:
        "bg-no-repeat bg-cover",
    imageCtaPadding:
        "!pt-[9.375rem] !pb-[9.375rem]",
    imageCtaCopy:
        "text-white rounded-[20px] bg-white/5 backdrop-blur-[20px] p-8",
}; 